__turbopack_context__.v({
  "backdrop": "modal-module__09A2QG__backdrop",
  "drawerPopup": "modal-module__09A2QG__drawerPopup",
  "hidden": "modal-module__09A2QG__hidden",
  "modalDrawerIn": "modal-module__09A2QG__modalDrawerIn",
  "popup": "modal-module__09A2QG__popup",
  "popupContent": "modal-module__09A2QG__popupContent",
});
